"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisifySubscribeToFileUploadConfirmation = exports.subscribeToFileUploadConfirmation = exports.createWebsocketConnection = void 0;
var js_websocket_client_lib_1 = __importDefault(require("@bynder/js-websocket-client-lib"));
var constants_1 = require("./constants");
var generic_1 = require("./helpers/generic");
var log = __importStar(require("./helpers/logger"));
var ws;
var createWebsocketConnection = function (isPublic) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, js_websocket_client_lib_1.default)('/ws', '/v7/socket.io.v2', null, !isPublic)];
            case 1:
                // First three arguments are taken from the websocket-client-lib.
                // These are default values.
                ws = _a.sent();
                return [2 /*return*/, ws];
        }
    });
}); };
exports.createWebsocketConnection = createWebsocketConnection;
var calculateSubscriptionTimeout = function (fileSize) {
    return constants_1.WEBSOCKET_SUBSCRIPTION_TIMEOUT_MS + fileSize * 0.01;
}; // + 10 sec. per Mb
var subscribeToFileUploadConfirmation = function (fileId, fileSize, correlationId, onSuccess, onFailure, isPublic, onSubscribed) { return __awaiter(void 0, void 0, void 0, function () {
    var connectionTimeout, joinRoomTimeout_1, subscriptionTimeout_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                if (!!ws) return [3 /*break*/, 2];
                connectionTimeout = (0, generic_1.promisifyTimeout)(constants_1.WEBSOCKET_INIT_TIMEOUT_MS, "Can't connect to websocket");
                return [4 /*yield*/, Promise.race([
                        (0, exports.createWebsocketConnection)(isPublic),
                        connectionTimeout.promise()
                    ]).then(function (result) {
                        if (result instanceof Error) {
                            throw result;
                        }
                    })];
            case 1:
                _a.sent();
                connectionTimeout.clear();
                _a.label = 2;
            case 2:
                joinRoomTimeout_1 = (0, generic_1.promisifyTimeout)(constants_1.WEBSOCKET_INIT_TIMEOUT_MS, 'Unable to join SocketIO room');
                return [4 /*yield*/, Promise.race([
                        ws.joinRoom("".concat(constants_1.WEBSOCKET_TOPIC_NAME, "_").concat(fileId)),
                        joinRoomTimeout_1.promise()
                    ]).then(function (result) {
                        if (result instanceof Error) {
                            throw result;
                        }
                        onSubscribed();
                        joinRoomTimeout_1.clear();
                    })];
            case 3:
                _a.sent();
                subscriptionTimeout_1 = (0, generic_1.promisifyTimeout)(calculateSubscriptionTimeout(fileSize), 'No WS success message received');
                Promise.race([
                    ws.promisifySubscribe(constants_1.WEBSOCKET_TOPIC_NAME, fileId, constants_1.WEBSOCKET_FILE_UPLOAD_SUCCESS_EVENT_NAME, null, true),
                    subscriptionTimeout_1.promise()
                ])
                    .then(function (result) {
                    if (result instanceof Error) {
                        throw result;
                    }
                    onSuccess(result);
                    subscriptionTimeout_1.clear();
                })
                    .catch(function (err) {
                    onFailure(err);
                });
                // TODO: Check status in FileUpload event
                // instead of subscribing for CommandFailed
                ws.subscribe(constants_1.WEBSOCKET_TOPIC_NAME, fileId, constants_1.WEBSOCKET_COMMAND_FAILED_EVENT_NAME, {
                    onSuccess: function (response) {
                        onFailure(new Error('Backend error: ' + response.reason));
                        subscriptionTimeout_1.clear();
                    },
                    onFailure: constants_1.noOp
                }, null, true);
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                log.info('Websocket error:');
                log.info(error_1);
                onFailure(error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.subscribeToFileUploadConfirmation = subscribeToFileUploadConfirmation;
var promisifySubscribeToFileUploadConfirmation = function (fileUpload) {
    return new Promise(function (resolve) {
        (0, exports.subscribeToFileUploadConfirmation)(fileUpload.fileId, fileUpload.file.size, null, function () {
            log.info("Confirmed: ".concat(fileUpload.id));
            fileUpload.uploader.events.onConfirmed(fileUpload.fileId, fileUpload.id);
        }, function (error) {
            fileUpload.uploader.events.onError(fileUpload.fileId, error, fileUpload.id);
            fileUpload.uploader.cancelUpload(fileUpload.fileId);
        }, fileUpload.uploader.isPublic, function () {
            log.info("Subscribed for: ".concat(fileUpload.id));
            resolve();
        });
    });
};
exports.promisifySubscribeToFileUploadConfirmation = promisifySubscribeToFileUploadConfirmation;
//# sourceMappingURL=websocket.js.map